module.exports = __webpack_public_path__ + "img/GG.5589a553.svg";